import { render, staticRenderFns } from "./RouteHistory.vue?vue&type=template&id=7b645aff&scoped=true"
import script from "./RouteHistory.vue?vue&type=script&lang=js"
export * from "./RouteHistory.vue?vue&type=script&lang=js"
import style0 from "./RouteHistory.vue?vue&type=style&index=0&id=7b645aff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b645aff",
  null
  
)

export default component.exports